import { render, staticRenderFns } from "./filter2.vue?vue&type=template&id=47431238"
import script from "./filter2.vue?vue&type=script&lang=js"
export * from "./filter2.vue?vue&type=script&lang=js"
import style0 from "./filter2.vue?vue&type=style&index=0&id=47431238&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports